import React from 'react';
import I18n from 'i18next';
import '../../assets/scss/modal.scss';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
};

export function Modal({ isOpen, onClose, title, children }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        {title !== undefined && (
          <div className="modal-header" >
            {title}
            <button
              type="button"
              aria-label={I18n.t('modal.close')}
              className="modal-close"
              onClick={onClose}
            >
              ×
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
